import React, { useState, useEffect, useCallback } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { ContentTitle, RightGrid } from '../ui/styled';
import { Auth } from 'aws-amplify';
import BackIcon from '../common/Back/BackIcon';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PageHeading from '../common/Heading/PageHeading';
import CommonSearch from '../common/Search/CommonSearch';
import { commonQueryParams } from '../../services/QueryParams/QueryParams';
import { paginationSize, VERIFICATION_LIST_URL } from '../../constants';
import { renderCellExpand } from '../common/GridCell/GridCellExpand';
import Button from '@mui/material/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getVerificationReferenceData } from '../../redux/verification/verificationMasterData';
import {
  newUpdateVerificationForm,
  verificationsList,
} from '../../redux/verification/VerificationSlice';
import { getVerificationMastreReferenceData } from '../../redux/verification/GetVerificationMasterReferenceData';
import { getVerificationList } from './services/verificationsApi';
import { LeftGrid } from '../Episode/Episode.Styled';

const VerificationList = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  if (id==0) {
    const verificationData = {
      month:  {id: '', value: ''},
      cbpId: '',
      month: '',
      provider: {cbpId: '', name: ''},
      startingMonday: {id: '', value: ''},
      week: ''
    }  
    dispatch(verificationsList(verificationData));
    navigate(`/weeklyVerification/details/0`);  
  }  
  const [user, setUser] = useState(null);
  const [searchVerificationList, setSearchVerificationList] = useState('');
  const [verificationList, setVerificationList] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 50,
    sortModel: '',
    filterModel: {linkOperator: 'and', items: [{ columnField: 'rcvd', operatorValue: 'is', value: 'false' }]}
  });

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    verificationList.pageSize,
    verificationList.page,
    verificationList.sortModel,
    verificationList.filterModel,
    searchVerificationList,
  ]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const QuickSearchToolbar = () => {
    return (
      <CommonSearch
        searchText={searchVerificationList}
        setSearchText={setSearchVerificationList}
      />
    );
  };

  const fetchData = async () => {
    setVerificationList((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = commonQueryParams(
      VERIFICATION_LIST_URL,
      searchVerificationList,
      verificationList
    );
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const verifications = await getVerificationList({
      commonParams,
      authorization,
    });
    setVerificationList((prveState) => ({
      ...prveState,
      ...verifications,
    }));
    dispatch(getVerificationReferenceData(authorization));
    dispatch(getVerificationMastreReferenceData(authorization));
  };

  const handleFilterChange = useCallback((filterModel) => {
    // Here you save the data you need from the filter model
    //console.log(filterModel);
    setVerificationList((prveState) => ({ ...prveState, filterModel: {...filterModel} }));
  }, []);

  const handleSortModelChange = useCallback((sortModel) => {
    // Here you save the data you need from the sort model
    setVerificationList((prveState) => ({
      ...prveState,
      sortModel: [...sortModel],
    }));
  }, []);

  const handelVerifyButton = (params) => {
    const { row } = params;
    const verificationList = {
      cbpId: row.cbpId,
      rcvd: row.rcvd,
      dateRcvd: row.dateRcvd,
      dateSent: row.dateSent,
      startingMonday: {
        id: row.verWeek,
        value: row.verWeek,
      },
      Month: {
        id: row.verMonth,
        value: row.verMonth,
      },
      week: row.verWeek,
      month: row.verMonth,
      provider: row.provider,
    };
    console.log('### verificationList')
    console.log(verificationList)
    dispatch(verificationsList(verificationList));
    navigate(`/weeklyVerification/details/${params.row.verId}`);
  };

  const handelNewVerificationForm = () => {
    const newEmptyVerificationForm = {
      newVerificationForm: true,
      cbpId: '',
      dateRcvd: '',
      dateSent: '',
      startingMonday: {
        id: '',
        value: '',
      },
      Month: {
        id: '',
        value: '',
      },
      provider: {
        cbpId: '',
        name: '',
      },
    };
    //dispatch(newUpdateVerificationForm(newEmptyVerificationForm));
    navigate(`/weeklyVerification/create`);
  };

  const columnsData = [
    { field: 'verId', headerName: 'Verification Id', flex: 1 },
    {
      field: 'verify',
      headerName: 'Verify',
      renderCell: (params) => {
        return (
          <Button
            variant='contained'
            onClick={() => handelVerifyButton(params)}
          >
            V
          </Button>
        );
      },
      flex: 1,
    },
    {
      field: 'feedback',
      headerName: 'Feedback',
      flex: 1,
    },
    {
      field: 'verWeek',
      headerName: 'Verification Week',
      minWidth: 80,
      type: 'date',
      flex: 1,
    },
    { field: 'verMonth', headerName: 'Verification Month', flex: 1 },
    {
      field: 'providerName',
      headerName: 'Provider',
      minWidth: 120,
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'cbpId',
      headerName: 'Cbp Id',
      flex: 1,
    },
    {
      field: 'dateSent',
      headerName: 'Date Sent',
      minWidth: 80,
      type: 'date',
      flex: 1,
    },
    { field: 'rcvd', headerName: 'Received', type: 'boolean', flex: 1 },
    {
      field: 'dateRcvd',
      headerName: 'Date Received',
      minWidth: 80,
      type: 'date',
      flex: 1,
    },
    {
      field: 'verificationContactName',
      headerName: 'Verification Contact',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'phone',
      headerName: 'Phone',
      renderCell: renderCellExpand,
      flex: 1,
    },
    { field: 'fax', headerName: 'Fax', renderCell: renderCellExpand, flex: 1 },
  ];

  return (
    <>
      <ContentTitle container>
        <RightGrid item xs={12} sm={4}>
          <BackIcon />
          <PageHeading title='Verification List' />
        </RightGrid>
        <Grid item xs={12} sm={4}>
          <Box style={{ alignItems: 'center' }}>
            <Typography variant='h4' align='center'>Verifications</Typography>
          </Box>
        </Grid>        
        <LeftGrid item xs={12} sm={4}>
          <Button
            variant='contained'
            onClick={() => handelNewVerificationForm()}
          >
            Release/Print Verifications
          </Button>
        </LeftGrid>
      </ContentTitle>
      <div style={{ height: 670, width: '100%' }}>
        <div style={{ display: 'flex', height: '100%' }}>
          <div style={{ flexGrow: 1 }}>
            <DataGridPro
              initialState={{
                filter: {
                  filterModel: {
                    linkOperator: 'and',
                    items: [{ columnField: 'rcvd', operatorValue: 'is', value: 'false' }],
                  },
                },
              }}
              //filterModel={{
              //  items: [{ columnField: 'rcvd', operatorValue: 'is', value: 'false' }],
              //}}
              filterMode="server"
              onFilterModelChange={handleFilterChange}
              //autoHeight
              //getRowHeight={() => 'auto'}
              columns={columnsData}
              rows={verificationList.data}
              pageSize={verificationList.pageSize}
              page={verificationList.page - 1}
              rowCount={verificationList.total}
              paginationMode='server'
              sortingMode='server'
              onSortModelChange={handleSortModelChange}
              //sortable={false}
              onPageSizeChange={(newPageSize) =>
                setVerificationList((prveState) => ({
                  ...prveState,
                  pageSize: newPageSize,
                }))
              }
              onPageChange={(newPage) => {
                setVerificationList((prveState) => ({
                  ...prveState,
                  page: newPage + 1,
                }));
              }}
              rowsPerPageOptions={paginationSize}
              pagination
              components={{ Toolbar: QuickSearchToolbar }}
              experimentalFeatures={{ newEditingApi: true }}        
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
              }
              loading={verificationList.isLoading}        
            />
          </div>
        </div>
      </div>      
    </>
  );
};
export default VerificationList;
